import { render, staticRenderFns } from "./settingsPasswords.vue?vue&type=template&id=3618d08c&scoped=true&"
import script from "./settingsPasswords.vue?vue&type=script&lang=js&"
export * from "./settingsPasswords.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3618d08c",
  null
  
)

export default component.exports